import type { DataUpload } from '@/common/data-upload';
import { axios } from '@/lib/utils/axios';

import { getResponse } from '../common';
import { API_URLS } from '../query.client';

/**
 * Asks the backend for the latest tile server status of a TILESET data upload.
 * The backend persists `tilesetUrl`/`tilesetStatus` when the job is ready.
 */
export async function getTilesetStatus(id: string): Promise<DataUpload | null> {
	const response = await axios.get(API_URLS.DATA_UPLOAD.TILESET_STATUS(id));
	return getResponse<DataUpload>(response.data);
}
